import type React from 'react';
// A small, consistent line-icon set for the owner phones (1.5px stroke, 16px grid).
export type IconName = 'ask' | 'parts' | 'history' | 'transfer' | 'recycle' | 'shield' | 'check' | 'chev' | 'back' | 'send' | 'doc' | 'tool' | 'user' | 'camera' | 'pin' | 'leaf' | 'box' | 'bolt' | 'lock' | 'play' | 'drop' | 'sun' | 'home' | 'pylon' | 'phone' | 'alert' | 'cal' | 'return' | 'cart';

const P: Record<IconName, React.ReactNode> = {
  ask: (
    <>
      <path d="M8 2.2 9.2 5.6 12.6 6.8 9.2 8 8 11.4 6.8 8 3.4 6.8 6.8 5.6z" />
      <path d="M12.4 10.6 13 12.2 14.6 12.8 13 13.4 12.4 15 11.8 13.4 10.2 12.8 11.8 12.2z" />
    </>
  ),
  parts: (
    <>
      <circle cx="8" cy="8" r="2.2" />
      <path d="M8 1.8v2M8 12.2v2M1.8 8h2M12.2 8h2M3.6 3.6l1.4 1.4M11 11l1.4 1.4M3.6 12.4 5 11M11 5l1.4-1.4" />
    </>
  ),
  history: (
    <>
      <path d="M2.5 8a5.5 5.5 0 1 0 1.6-3.9" />
      <path d="M2.3 2.6v2.6h2.6M8 5v3.2l2.2 1.4" />
    </>
  ),
  transfer: <path d="M2.5 5.5h10M10 3l2.5 2.5L10 8M13.5 10.5h-10M6 8l-2.5 2.5L6 13" />,
  recycle: <path d="M5.2 4.6 6.9 1.9a1.3 1.3 0 0 1 2.2 0l1.2 2M12.4 7.2l1.3 2.3a1.3 1.3 0 0 1-1.1 1.9H9.4M6.6 11.4H3.4a1.3 1.3 0 0 1-1.1-1.9l1.6-2.8M10.6 2.8l-.3 1.9-1.9-.3M8.2 12.8l1.2-1.4-1.3-1.5M2.6 5.9l1.3 1.6 1.8-.7" />,
  shield: (
    <>
      <path d="M8 1.8 13 3.6v4c0 3.2-2.1 5.4-5 6.6-2.9-1.2-5-3.4-5-6.6v-4z" />
      <path d="m5.6 8 1.7 1.7L10.6 6.4" />
    </>
  ),
  check: <path d="m3.5 8.2 2.9 2.8 6.1-6.2" />,
  chev: <path d="m6 3.5 4.5 4.5L6 12.5" />,
  back: <path d="M10 3.5 5.5 8l4.5 4.5" />,
  send: <path d="M8 13V3.5M3.8 7.6 8 3.4l4.2 4.2" />,
  doc: (
    <>
      <path d="M4 1.8h5.2L12 4.6v9.6H4z" />
      <path d="M9 1.8v3h3M6 8h4M6 10.6h4" />
    </>
  ),
  tool: <path d="M10.6 2.2a3.2 3.2 0 0 0-3.9 4.2L2.4 10.7a1.4 1.4 0 0 0 2 2l4.3-4.3a3.2 3.2 0 0 0 4.2-3.9l-1.9 1.9-1.8-.4-.4-1.8z" />,
  user: (
    <>
      <circle cx="8" cy="5.6" r="2.7" />
      <path d="M2.8 14c.6-2.6 2.7-4.1 5.2-4.1s4.6 1.5 5.2 4.1" />
    </>
  ),
  camera: (
    <>
      <path d="M2 5.2h2.6L6 3.4h4l1.4 1.8H14v7.6H2z" />
      <circle cx="8" cy="8.8" r="2.3" />
    </>
  ),
  pin: (
    <>
      <path d="M8 14.2s4.6-4 4.6-7.6a4.6 4.6 0 0 0-9.2 0c0 3.6 4.6 7.6 4.6 7.6z" />
      <circle cx="8" cy="6.6" r="1.6" />
    </>
  ),
  leaf: <path d="M3 13c0-6 3.6-9.6 10-10 0 6.6-3.4 10-8.6 10M3 13l5-5" />,
  box: <path d="M2.4 4.8 8 2l5.6 2.8v6.4L8 14l-5.6-2.8zM2.4 4.8 8 7.6l5.6-2.8M8 7.6V14" />,
  bolt: <path d="M9 1.8 3.6 9h4l-.6 5.2L12.4 7h-4z" />,
  lock: (
    <>
      <rect x="3.2" y="7" width="9.6" height="7" rx="1.6" />
      <path d="M5.4 7V5a2.6 2.6 0 0 1 5.2 0v2" />
    </>
  ),
  play: <path d="M5.2 3.4v9.2L12.6 8z" />,
  drop: <path d="M8 1.9s4.4 4.6 4.4 7.6a4.4 4.4 0 0 1-8.8 0C3.6 6.5 8 1.9 8 1.9z" />,
  sun: (
    <>
      <circle cx="8" cy="8" r="2.8" />
      <path d="M8 1.5v1.6M8 12.9v1.6M1.5 8h1.6M12.9 8h1.6M3.4 3.4l1.1 1.1M11.5 11.5l1.1 1.1M3.4 12.6l1.1-1.1M11.5 4.5l1.1-1.1" />
    </>
  ),
  home: <path d="M2.2 7.4 8 2.6l5.8 4.8M3.8 6.2v7.6h8.4V6.2M6.6 13.8V10h2.8v3.8" />,
  pylon: <path d="M8 1.8 5 14.2M8 1.8l3 12.4M3.4 5h9.2M4.4 9h7.2M5.8 11.6l4.4-2.6M10.2 11.6 5.8 9" />,
  phone: <path d="M4.6 2.2h2l1 3-1.5 1a7.4 7.4 0 0 0 3.7 3.7l1-1.5 3 1v2c0 .9-.7 1.6-1.6 1.6A10.6 10.6 0 0 1 3 3.8c0-.9.7-1.6 1.6-1.6z" />,
  alert: (
    <>
      <path d="M8 2.2 14.2 13H1.8z" />
      <path d="M8 6.4v3M8 11.2v.1" />
    </>
  ),
  cal: (
    <>
      <rect x="2.4" y="3.4" width="11.2" height="10.4" rx="1.6" />
      <path d="M2.4 6.6h11.2M5.4 1.9v2.6M10.6 1.9v2.6" />
    </>
  ),
  return: <path d="M5.6 4.2 2.6 7.2l3 3M2.8 7.2h7a3.6 3.6 0 0 1 0 7.2H7.4" />,
  cart: (
    <>
      <path d="M1.8 2.6h2l1.6 7.6h7l1.4-5.4H4.6" />
      <circle cx="6.4" cy="13" r="1" />
      <circle cx="11.6" cy="13" r="1" />
    </>
  ),
};

export function Icon({ name, size = 14, className, stroke = 1.5 }: { name: IconName; size?: number; className?: string; stroke?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      {P[name]}
    </svg>
  );
}
